<template>
	<div v-if="commonService.isMobile()" class="p-grid p-fluid p-justify-center" style="margin-top: -40px;">
		<HomeHeader />
		<div class="p-col-12">
			<div>
				<Toast />
				<div class="p-grid">
					<template v-if="emailSent">
						<div class="p-col-12">
							<div class="p-messages p-component p-messages-success" style="margin: 0 0 1em 0; display: block">
								<div class="p-messages-wrapper">
									<span class="p-messages-icon pi pi-fw pi-2x pi-check"></span>
									<span class="p-messages-detail">{{$t('recoverySentMessage', { email: this.email })}}
									</span>
								</div>
							</div>
						</div>
						<div class="p-col-4">
							<router-link to="/login">
								<Button :label="$t('login')" />
							</router-link>
						</div>
					</template>
					<template v-else>
						<div class="p-col-12">
							<label htmlFor="acSimple">{{$t('email')}}</label>
						</div>
						<div class="p-col-12">
							<InputText v-model="email" :class="{ 'p-error': recoveryClicked && !email }" />
						</div>
						<div class="p-col-4 p-md-3" style="margin-top: 20px">
							<Button :label="$t('recovery')" @click="recovery" />
						</div>
						<div class="p-col" style="margin-top: 20px">
							<div class="p-col">
								<router-link to="/login">{{$t('cancel')}}</router-link>
							</div>
						</div>
						<div class="p-col-4 p-md-3" style="margin-top: 20px">
							<LanguageSelector />
						</div>
					</template>
				</div>
			</div>
		</div>
		<HomeFoot />
	</div>
	<div v-else class="p-grid p-fluid p-justify-center" style="margin-top: -40px;">
		<HomeHeader />
		<div class="p-col-12 p-lg-3 margin-top margin-left-right" style="width: 45%;">
			<div class="card card-w-title" style="margin: 40px; width: 70%; margin-left: auto; margin-right: auto;">
				<Toast />
				<div class="card card-w-title" style="margin: 40px; width: 85%;">
					<h1>{{$t('recovery')}}</h1>
					<div class="p-grid">
						<template v-if="emailSent">
							<div class="p-col-12">
								<div class="p-messages p-component p-messages-success" style="margin: 0 0 1em 0; display: block">
									<div class="p-messages-wrapper">
										<span class="p-messages-icon pi pi-fw pi-2x pi-check"></span>
										<span class="p-messages-detail">{{$t('recoverySentMessage', { email: this.email })}}
										</span>
									</div>
								</div>
							</div>
							<div class="p-col-4">
								<router-link to="/login">
									<Button :label="$t('login')" />
								</router-link>
							</div>
						</template>
						<template v-else>
							<div class="p-col-12" style="margin-top: 10px">
								<label htmlFor="acSimple">{{$t('email')}}</label>
							</div>
							<div class="p-col-12">
								<InputText v-model="email" :class="{ 'p-error': recoveryClicked && !email }" />
							</div>
							<div class="p-col-5 p-md-3" style="margin-top: 20px">
								<Button :label="$t('recovery')" @click="recovery" />
							</div>
							<div class="p-col" style="margin-top: 20px">
								<div class="p-col">
									<router-link to="/home">{{$t('cancel')}}</router-link>
								</div>
							</div>
							<div class="p-col-4 p-md-3" style="margin-top: 20px">
								<LanguageSelector />
							</div>
						</template>
					</div>
				</div>
			</div>
		</div>
		<HomeFoot />
	</div>
</template>

<script>
import AuthService from "@/service/AuthService";
import CommonService from "@/service/CommonService";
import HomeFoot from "@/components/home/HomeFoot";
import HomeHeader from "@/components/home/HomeHeader";

export default {
	components: {
		HomeFoot,
		HomeHeader,
	},
	data() {
		return {
			email: "",
			recoveryClicked: false,
			emailSent: false,
		};
	},
	beforeCreate: function () {
		document.body.className = "login";
	},
	authService: null,
	commonService: null,
	created() {
		this.authService = new AuthService();
		this.commonService = new CommonService();
	},
	methods: {
		recovery() {
			this.recoveryClicked = true;
			if (this.email) {
				this.authService
					.recoverPassword(this.email, this.$i18n.locale)
					.then((res) => {
						this.emailSent = true;
						return res;
					})
					.catch((error) => {
						self.$router.push("/login");
						return error;
					});
			}
		},
		login() {
			this.$router.push("/login");
		},
		register() {
			this.$router.push("/register");
		},
	},
};
</script>

<style scoped>
.margin-top-left {
	margin-top: 110px !important;
}

.margin-top {
	margin-top: 70px !important;
}

.margin-left-left {
	margin-left: 90px !important;
}

.margin-left-right {
	margin-left: -120px !important;
}

.login-box {
	background-color: #94b8ca;
	border-radius: 25px;
	width: 40%;
}

.login-title {
	margin-top: -15px;
	font-size: 65px;
	font-weight: bold;
}

.login-subtitle {
	margin-top: -80px;
	font-size: xx-large;
	font-weight: bold;
}

.login-text {
	margin-top: 10px;
	font-size: 22px;
}

.brand-text {
	font-size: 20px;
	font-weight: bold;
	margin: auto 30px;
}

@media (min-width: 1000px) and (max-width: 1600px) {
	.margin-top-left {
		margin-top: 45px !important;
	}

	.margin-top {
		margin-top: 45px !important;
	}

	.margin-left-right {
		margin-left: -50px !important;
	}

	.login-title {
		font-size: 50px;
	}
	.login-subtitle {
		font-size: 25px;
		margin-top: -60px;
	}

	.login-text {
		font-size: 20px;
	}
}

@media (min-width: 1000px) and (max-width: 1600px) {
	.brand-text {
		margin-top: 8px;
		font-size: 15px;
		font-weight: bold;
	}
}

.login-title-mobile {
	margin-top: -10px;
	font-size: 35px;
	font-weight: bold;
}

.login-subtitle-mobile {
	margin-top: -40px;
	font-size: 20px;
	font-weight: bold;
}

.login-text-mobile {
	margin-top: 10px;
	font-size: 15px;
}
</style>
